<template>
    <div class="row">
        <div class="col-12">
          <BackendUyJoySynchronization/>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                      <tr>
                          <th>Категория</th>
                          <th>Текст</th>
                          <th>Текст(ru)</th>
                          <th>Актив</th>
                          <th>Парент</th>
                          <th>Жараён</th>
                      </tr>
                  </thead>
                  <tbody v-if="!loading && sections && sections.data">
                      <tr v-for="result in sections.data" :key="result.id">
                          <td>
                              <span v-if="result.category === 'Notorious'">Нотурар</span>
                              <span v-if="result.category === 'Residential'">Турар</span>
                          </td>
                          <td>{{ result.label }}</td>
                          <td></td>
                          <td>{{result.active ? 'Ха' : 'Йўқ'}}</td>
                          <td v-if="result.parent">{{ result.parent.label }}</td>
                          <td v-else></td>
                          <td class="td-actions text-center">
                              <button class="all-btn edit-btn table-action" data-original-title="Edit"
                              @click="showSectionEditModal(result)">
                                  <i class="fa fa-edit"></i>
                              </button>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && sections && sections.data && sections.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && sections && sections.total && sections.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="sections.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <BuildingSectionEditModal/>
    </div>
</template>

<script>

    import BackendUyJoySynchronization from './BackendUyJoySynchronization'
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import BuildingSectionEditModal from './BuildingSectionEditModal'

    export default {
        components: {
            'b-pagination': bPagination,
            BackendUyJoySynchronization: BackendUyJoySynchronization,
            BuildingSectionEditModal: BuildingSectionEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                sections: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('/building/section/list', this.filter)
                    .then(res => {
                        this.sections = res.data;
                        this.loading = false
                    }, err => {
                        console.log(err);
                        this.loading = false
                    })
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showSectionEditModal(data) {
                this.$eventBus.$emit("showSectionEditModal", data)
            }
        },
        created() {
            this.filter.parentOnly = true;
            this.initList();
            this.$eventBus.$on("initSectionList", () => {
                this.initList()
            })
        }
    }
</script>

<style scoped>

</style>